var link_viewer_wrapper_default = {
  "anchor": "_9kqvn",
  "link": "ssyAj"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
